const state = {
    viewAs: "grid",
    shadowQuery: '',
};

// getters
const getters = {
    viewAs: state => state.viewAs,
    shadowQuery: state => state.shadowQuery,
};

// actions
const actions = {};

// mutations
const mutations = {
    setSearchView(state, value) {
        state.viewAs = value;
    },
    setShadowQuery (state, value) {
        state.shadowQuery = value
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
